<div>
    <!-- Alarm Tab -->
    <div>
        <div class="value-display-container">
            <!-- Analog Value Display -->

            <div class="channel-data">
                <div class="channel-value" *ngIf="!isDigital()">
                    <div class="alarm-range-container" #range>
                        <div class="range-container">
                            <app-channel-alarm-range
                                [channel]="channel"
                                [value]="getRawValue()"
                                [status]="getStatus()"
                            ></app-channel-alarm-range>
                            <div class="measurable-range highlighted text-large light">
                                <div>{{ getMeasurableMin() }}</div>
                                <div>{{ getMeasurableMax() }}</div>
                            </div>
                        </div>
                    </div>
            
                    <!-- Alarm Thresholds -->
                    <div class="alarm-range-list-container">
                        <app-alarm-range-list [channel]="channel">
                        </app-alarm-range-list>
                    </div>
                </div>
                <div class="about">
                    <div class="about-continer">
                        <div class="about-header">
                            {{ "forms.channel.about.input-header" | translate }}
                        </div>
                        <div class="about-detail-group">
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.address" | translate }}
                                </div>
                                <div class="column-value text light">{{ ADDRESS_STRING + getInputAddress() }}</div>
                            </div>
        
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.name" | translate }}
                                </div>
                                <div class="column-value text light">{{ ADDRESS_STRING + getFcuNum() }}</div>
                            </div>

                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.channel-type" | translate }}
                                </div>
                                <div class="column-value text light">{{ getChannelType() }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="about-continer">
                        <div class="about-header">
                            {{ "forms.channel.about.output-header" | translate }}
                        </div>
                        <div class="about-detail-group">
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.address" | translate }}
                                </div>
                                <div class="text light">{{ ADDRESS_STRING + getOutputAddress() }}</div>
                            </div>
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.name" | translate }}
                                </div>
                                <div class="text light">{{ ADDRESS_STRING + getFcuNum() }}</div>
                            </div>
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.signal-type" | translate }}
                                </div>
                                <div class="text light">{{ getOutputSignalType() }}</div>
                            </div>
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.output-data" | translate }}
                                </div>
                                <div class="text light">*</div>
                            </div>
                            <div class="column">
                                <div class="column-name text highlighted">
                                    {{ "forms.channel.about.signal-data" | translate }}
                                </div>
                                <div class="text light">{{ "00000000 00000000 00000000 00000000" }}</div>
                            </div>
                        </div>
                    </div>
        
                    <div class="about-continer">
                        <div class="about-header caption">
                            {{ "forms.channel.about.mimics-header" | translate }}
                        </div>
                        <div class="list-container">
                            <div *ngFor="let mimic of mimics" class="mimic-name">
                                <button
                                    class="border"
                                    (click)="toMimicView(mimic.id)"
                                >
                                    {{ mimic.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="about-continer">
                        <div class="about-header caption">
                            {{
                                "forms.channel.about.trend-graphs-header"
                                    | translate
                            }}
                        </div>
                        <div class="list-container">
                            <div *ngFor="let trendGraph of trendGraphs">
                                <button
                                    class="border"
                                    (click)="toTrendGraphView(trendGraph.id)"
                                >
                                    {{ trendGraph.name }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>        
            </div>

        <!-- Alarm Edit Forms -->
        <div class="alarm-form-container">
            <!-- Analog Alarms -->
            <div *ngIf="isAnalog()" class="alarms-container-spacing">
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.veryHigh"
                    title="channel.label.alarm.high-high"
                    [disableFields]="['timer']"
                    [validator]="validators.veryHigh"
                    [alarm]="channel.fcuData.alarmSettingVeryHigh"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingVeryHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingVeryHigh', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.high"
                    title="channel.label.alarm.high"
                    [disableFields]="['timer']"
                    [validator]="validators.high"
                    [alarm]="channel.fcuData.alarmSettingHigh"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingHigh', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.low"
                    title="channel.label.alarm.low"
                    [disableFields]="['timer']"
                    [validator]="validators.low"
                    [alarm]="channel.fcuData.alarmSettingLow"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingLow', $event)"
                    (onDelete)="emitDelete('alarmSettingLow', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.veryLow"
                    title="channel.label.alarm.low-low"
                    [disableFields]="['timer']"
                    [validator]="validators.veryLow"
                    [alarm]="channel.fcuData.alarmSettingVeryLow"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingVeryLow', $event)"
                    (onDelete)="emitDelete('alarmSettingVeryLow', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.feedback"
                    title="channel.label.alarm.feedback"
                    [isFeedbackAlarm]="true"
                    [disableFields]="['setPoint']"
                    [validator]="validators.feedback"
                    [alarm]="channel.fcuData.alarmSettingFeedbackError"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    [isFeedbackAlarm]="true"
                    [disableFields]="['setPoint']"
                    (onSubmit)="emitSubmit('alarmSettingFeedbackError', $event)"
                    (onDelete)="emitDelete('alarmSettingFeedbackError', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.sensorFail"
                    [validator]="validators.sensorFail"
                    title="channel.label.alarm.sensor-failure"
                    [isFeedbackAlarm]="false"
                    [alarm]="channel.fcuData.alarmSettingSensorFail"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    [disableFields]="['setPoint', 'timer']"
                    (onSubmit)="emitSubmit('alarmSettingSensorFail', $event)"
                    (onDelete)="emitDelete('alarmSettingSensorFail',$event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </div>
            <div *ngIf="isDigital()" class="alarms-container-spacing">
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.alarmSetting"
                    [validator]="validators.alarmSetting"
                    title="channel.label.alarm.digital"
                    [disableFields]="['setPoint', 'timer']"
                    [alarm]="channel.fcuData.digitalAlarmSetting"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('digitalAlarmSetting', $event)"
                    (onDelete)="emitDelete('digitalAlarmSetting', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </div>
            <div *ngIf="isRunningHour()" class="alarms-container-spacing">
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.veryHigh"
                    [validator]="validators.veryHigh"
                    title="channel.label.alarm.high-high"
                    [disableFields]="['timer']"
                    [alarm]="channel.fcuData.alarmSettingVeryHigh"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingVeryHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingVeryHigh', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
                <app-alarm-setting-form
                    #alarmSettingForm
                    *ngIf="validators.high"
                    [validator]="validators.high"
                    title="channel.label.alarm.high"
                    [disableFields]="['timer']"
                    [alarm]="channel.fcuData.alarmSettingHigh"
                    [measurementUnits]="channel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingHigh', $event)"
                    [channel]="channel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </div>
        </div>
    </div>
</div>

<!-- Bottom buttons -->
<div class="dropdown-setting">
    <div class="manual-repose-container">
        <div class="caption">
            {{ "forms.channel.alarm.manual-repose" | translate }}
        </div>
        <app-repose-toggle
            #globalRepose
            class="repose-toggle"
            [checked]="getGlobalReposeValue()"
            (toggleCheckedClick)="onGlobalReposeClicked($event)"
        ></app-repose-toggle>
    </div>
    <div class="bottom-buttons">
        <button class="border caption" (click)="emitAdvancedDetails()">
            <mat-icon svgIcon="expand-details" class="details-icon"></mat-icon>
            {{ "forms.channel.alarm.buttons.advanced-settings" | translate }}
        </button>
        <button class="primary caption" (click)="onClose()">
            {{ "forms.channel.alarm.buttons.close" | translate }}
        </button>
    </div>
</div>
